module.exports = __webpack_public_path__ + "/images/cover-mujer-embarazada-transparete.39299ee.webp";